import axios from "../../MyAxios";
import { GET_TOKEN } from "../../constants/api";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setIsLoggedIn, setUserRecord } from "../../redux/userSlice";
import { GET_LOGGED_USER } from "../../constants/api";

const AuthCallback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userToken, setUserToken] = useState();
  const { token } = useParams();
  const getToken = async () => {
    const res = await axios.get(`${GET_TOKEN}/${token}`);
    setUserToken(res.data);
  };
  useEffect(() => {
    if (token) {
      getToken();
      if (userToken) {
        localStorage.setItem("token", userToken);
        dispatch(setIsLoggedIn(true));

        // Fetch user profile immediately after login
        axios.get(GET_LOGGED_USER).then((res) => {
          dispatch(setUserRecord(res.data));
          navigate("/", { replace: true });
        }).catch(() => {
          navigate("/", { replace: true });
        });
      }
    }
  }, [token, userToken]);
};

export default AuthCallback;
